import {Component} from "@angular/core";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import "rxjs/add/operator/toPromise";
import {Observable} from "rxjs";
import {handleErrors} from "../../misc/handle-errors.decorator";

export interface CreatePurchaseOrdersDialogModel {
  purchaseOrders: any[];
}

@Component({
  templateUrl: "./purchase-orders-create-dialog.template.pug",
})
export class PurchaseOrdersCreateDialogComponent
  extends DialogComponent<CreatePurchaseOrdersDialogModel, any> implements CreatePurchaseOrdersDialogModel {
  public purchaseOrderNumber: string = "";
  public purchaseOrderDescription: string = "";
  public purchaseOrdersCategory: string = "customerPO";
  purchaseOrders: any[] = [];
  public error: Error;

  static showCreatePurchaseOrdersDialogModal(
    dialogService: DialogService,
    inputs: CreatePurchaseOrdersDialogModel,
  ): Observable<any> {
    return dialogService.addDialog(
      PurchaseOrdersCreateDialogComponent,
      inputs,
      {backdropColor: "rgba(0, 0, 0, 0.5)"},
    );
  }

  cancel(): void {
    this.result = {};
    this.close();
  }

  @handleErrors()
  async create(): Promise<void> {
    // Validate they are not trying to create an existing PO
    const existingPO = this.purchaseOrders.find(it => it.purchaseOrderNumber === this.purchaseOrderNumber);
    if (existingPO && existingPO.purchaseOrderNumber !== "Pending PO") {
      throw new Error("The Purchase Order already exists, please try again.");
    }
    this.result = {
      purchaseOrderNumber: this.purchaseOrderNumber,
      purchaseOrderDescription: this.purchaseOrderDescription,
      pendingPO: this.purchaseOrdersCategory === "pendingPO",
    };
    this.close();
  }

  updatePurchaseOrders(event) {
    if (event === "pendingPO") {
      this.purchaseOrderNumber = "Pending PO";
      this.purchaseOrderDescription = "";
    }
    if (event === "customerPO") {
      this.purchaseOrderNumber = "";
      this.purchaseOrderDescription = "";
    }
  }

  constructor(
    public dialogService: DialogService,
  ) {
    super(dialogService);
  }
}
